import { render, staticRenderFns } from "./qcentriscountryRelation.vue?vue&type=template&id=45019305&scoped=true&"
import script from "./qcentriscountryRelation.vue?vue&type=script&lang=js&"
export * from "./qcentriscountryRelation.vue?vue&type=script&lang=js&"
import style0 from "./qcentriscountryRelation.vue?vue&type=style&index=0&id=45019305&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45019305",
  null
  
)

export default component.exports